module.exports = __webpack_public_path__ + "static/media/01.32499805.jpg";